import { render } from "./LinuxCheatSheet.vue?vue&type=template&id=0d8c5144&scoped=true"
const script = {}

import "./LinuxCheatSheet.vue?vue&type=style&index=0&id=0d8c5144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8c5144"]])

export default __exports__